// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ke-3";
export var downloadButton = "_ke-4";
export var fileContainer = "_ke-9 _ke-7";
export var fileContainerBase = "_ke-7";
export var fileContainerBaseSm = "_ke-a _ke-7";
export var fileContainerFixedHeight = "_ke-8 _ke-7";
export var fileContainerFixedHeightSm = "_ke-c _ke-a _ke-7";
export var fileContainerSm = "_ke-b _ke-a _ke-7";
export var fileInfo = "_ke-5";
export var fileInfoWidthRestricted = "_ke-6";
export var fileType = "_ke-1";
export var fileTypeName = "_ke-2";
export var fileTypeSm = "_ke-d _ke-1";
export var image = "_ke-0";
export var link = "_ke-f";
export var overflowEllipsis = "_ke-e";